import './DisabledAlert.scss';
import { Button } from 'antd';
import React from 'react';
import { SonarAlert } from '@ui/SonarAlert';
import { SonarText } from '@ui/text';
import { CHANGE_EVENT_PREFERENCES, LINKS } from '@sonar-software/sonar-ts-constants';

export const DisabledAlert : React.FC = () =>
	<SonarAlert
		active
		closable
		message={
			<div className='disabled-message'>
				<SonarText>{ CHANGE_EVENT_PREFERENCES.DISABLED_TEXT }</SonarText>
				<Button
					className='help-text-button'
					onClick={ () => window.open(LINKS.PULSE_HELP_ARTICLE) }
					type='primary'>
					{ CHANGE_EVENT_PREFERENCES.READ_HELP_ARTICLE }
				</Button>
			</div>
		}
		showIcon
		type='error' />;
